import Quasar from 'quasar/src/vue-plugin.js';;
import { createApp } from "vue";
import App from "./App.vue";
import quasarUserOptions from "./quasar-user-options";

createApp(App, { windowLocationSearch: window.location.search }).use(Quasar, quasarUserOptions).mount("#app");
